import moment from 'moment';

/**
 * https://github.com/moment/moment/issues/3375
 *
 * Align French-Swiss day-of-month ordinals with French calendar dates.
 * moment `fr` uses `1er` then bare numbers for `Do`; `fr-ch` wrongly
 * yields `27e` (same class of bug as fr-ca; fr-ch never fixed upstream).
 * Related PR (fr-ca only): https://github.com/moment/moment/pull/6449
 *
 * Kronos maps fr → fr-ch for Swiss separators; keep that, fix `Do` only.
 */
let patched = false;

export function patchMomentFrChOrdinal() {
    if (patched)
        return;

    moment.updateLocale('fr-ch', {
        ordinal(number, period) {
            switch (period) {
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    patched = true;
}
